import React from "react";
import styled from "styled-components";
import PaginationWrapper from "../../components/shared/pagination/PaginationWrapper";
import { useSelector } from "react-redux";
import SelectItemWrapper from "../../components/shared/SelectItemWrapper";
import SelectItemsContextWrapper from "../../components/shared/SelectItemsContextWrapper";
import CustomFilterWrapper from "../booking-instruments/booking-instruments-custom-filter/CustomFilterWrapper";
import AdminTabs from "./AdminTabs";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import { useParams } from "react-router-dom";

const MainViewStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  pading-bottom: 8px;
  flex-grow: 1;
  overflow: hidden;
`;

export const compareBooking = (x, y) => x?.id === y?.id;
export const MainView = ({ setSubscriptionStatus, subscriptionStatus, setPopupEnableStatus }) => {
  const storeUser = useSelector((store) => store.user);
  const { trackPageView } = useMatomo();
  const { EventID } = useParams();
  const eventID = EventID || null;

  // Determine action from URL path
  const currentPath = window.location.pathname;
  let urlAction = null;
  if (EventID) {
    if (currentPath.includes('/review/')) {
      urlAction = 'review';
    }
  }

  React.useEffect(() => {
    trackPageView({
      documentTitle: "Admin Panel",
      href: `${window.location?.origin}/AdminPanel`,
    });
    // eslint-disable-next-line
  }, []);

  return (
    <SelectItemsContextWrapper compareItem={compareBooking}>
      <SelectItemWrapper>
        <PaginationWrapper>
          <CustomFilterWrapper initialValues={{ site: storeUser?.site }}>
            <MainViewStyled>
              <AdminTabs
                setSubscriptionStatus={setSubscriptionStatus}
                subscriptionStatus={subscriptionStatus}
                setPopupEnableStatus={setPopupEnableStatus}
                eventID={eventID}
                urlAction={urlAction}
              />
            </MainViewStyled>
          </CustomFilterWrapper>
        </PaginationWrapper>
      </SelectItemWrapper>
    </SelectItemsContextWrapper>
  );
};

export default MainView;
